import React from 'react';

function TransfersAccountIcon() {
  return (
    <svg height={19.2} style={{ display: 'block' }} width={31.485} xmlns="http://www.w3.org/2000/svg">
      <g data-name="picto-transferer compte client KAM">
        <path
          d="M23.403 2.606l7.431 7.432-7.431 7.431"
          data-name="Trac\xE9 276"
          fill="#fff"
          stroke="#202124"
          strokeLinejoin="round"
          strokeWidth={1.3}
        />
        <g data-name="Groupe 1841">
          <g data-name="Groupe 1846">
            <path
              d="M23.403 2.606l7.431 7.432-7.431 7.431"
              data-name="Trac\xE9 277"
              fill="none"
              stroke="#202124"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.3}
            />
          </g>
        </g>
        <path
          d="M20.291 10.023h0z"
          data-name="Trac\xE9 278"
          fill="#fff"
          stroke="#202124"
          strokeLinejoin="round"
          strokeWidth={1.3}
        />
        <g
          data-name="Groupe 1568"
          fill="none"
          stroke="#202124"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        >
          <path
            d="M18.6 18.601a17.059 17.059 0 00-1.956-6.49 5.856 5.856 0 00-1.951-1.995C12.742 8.894 6.41 9.049 4.5 10.115a6.714 6.714 0 00-2.783 3.777A27.165 27.165 0 00.6 18.601zm-5.458-14.5a3.64 3.64 0 01-1.031 2.478 3.361 3.361 0 01-2.482 1.022 3.5 3.5 0 113.513-3.5z"
            data-name="Trac\xE9 218"
          />
          <path d="M6.019 18.6v-5.785" data-name="Ligne 231" />
          <path d="M13.143 18.6v-5.785" data-name="Ligne 232" />
        </g>
      </g>
    </svg>
  );
}

export default TransfersAccountIcon;
